// extracted by mini-css-extract-plugin
export default {"container":"reactAccordion_container__I5K+q","accordion_container":"reactAccordion_accordion_container__SINMl","answer":"reactAccordion_answer__8SJoq"};